const elements = '[name="checkout"], .cart__checkout-button, .button.button-checkout, button[name="checkout"]';

window.turnstileSuccess = function(token) {
    onTurnstileSuccess();
};

function renderTurnstile() {
    if (window.turnstile) {
        turnstile.render("#turnstile-container", {
            sitekey: "0x4AAAAAAD6mX-kLmZVTgTLp",
            callback: function() {
                onTurnstileSuccess();
            },
            size: "flexible"
        });
    } else {
        setTimeout(renderTurnstile, 100);
    }
}

function renderTurnstileMorePayment() {
    if (window.turnstile && jQuery("#turnstile-container-more-payment").length > 0) {
        turnstile.render("#turnstile-container-more-payment", {
            sitekey: "0x4AAAAAAD6mX-kLmZVTgTLp",
            callback: function() {
                onTurnstileMorePaymentSuccess();
            },
            size: "flexible"
        });
    } else {
        setTimeout(renderTurnstileMorePayment, 100);
    }
}

function onTurnstileSuccess() {
    jQuery(elements).attr("disabled", false);
}

function onTurnstileMorePaymentSuccess() {
    jQuery(".shopify-payment-button").css("display", "block");
}

jQuery(document).ready(function() {
    if (jQuery('.shopify-payment-button').length > 0) {
        jQuery('.productView-payment').before("<div id='turnstile-container-more-payment'></div>");
        jQuery('.shopify-payment-button').css("display", "none");
        renderTurnstileMorePayment();
    }
});